module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-03@2x.2a17456f.jpg";